import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo, useState } from 'react';
const TransparencyContext = createContext(null);
export function TransparencyProvider({ children }) {
    const [mode, setMode] = useState('themed');
    const value = useMemo(() => ({
        mode,
        setMode,
        isEnabled: mode !== 'off',
    }), [mode]);
    return _jsx(TransparencyContext.Provider, { value: value, children: children });
}
export function useTransparencyMode() {
    const context = useContext(TransparencyContext);
    if (!context) {
        return {
            mode: 'themed',
            setMode: () => { },
            isEnabled: true,
        };
    }
    return context;
}
